import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

function PrivacyPolicy() {
  const navigate = useNavigate();

  useEffect(() => {
    // Load Termly embed script
    if (!document.getElementById('termly-jssdk')) {
      const script = document.createElement('script');
      script.id = 'termly-jssdk';
      script.src = 'https://app.termly.io/embed-policy.min.js';
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      {/* Header bar */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="text-slate-500 hover:text-slate-800 transition-colors p-1"
            data-testid="privacy-back-btn"
          >
            <ArrowLeft size={20} weight="bold" />
          </button>
          <h1 className="text-lg font-semibold text-slate-900">Privacy Policy</h1>
        </div>
      </header>

      {/* Policy content */}
      <main className="flex-1 max-w-4xl mx-auto w-full px-6 py-8" data-testid="privacy-policy-page">
        <div
          name="termly-embed"
          data-id="b614a481-f914-4c67-bd1c-d3d111ba6495"
          data-testid="termly-embed"
          className="prose prose-slate max-w-none"
        />
      </main>
    </div>
  );
}

export default PrivacyPolicy;
